/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'utils/hooks';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';

import crmNotificationsApi from 'api/crmNotificationsApi';
import {
  markNotificationsAsRead,
  markNotificationsAsReadByIds,
} from 'store/notifications/reducer';
import { getUnreadedNotificationsCount } from 'utils/helpers';
import {
  StyledPaper,
  StyledPopper,
} from './components/NotificationsModal.styles';
import SettingsIcon from './components/SettingsIcon';
import NotificationRecord from './components/NotificationRecord/NotificationRecord';

import NoInfo from './components/NoInfo';
import UnstyledButton from '../UnstyledButton';

type Props = {
  isOpen: boolean;
  handleClose: () => void;
  notificationsList: any[];
}

const NotificationsModal = React.forwardRef<any, Props>(
  (props, anchorRef) => {
    const dispatch = useAppDispatch();
    const { user } = useAppSelector(({ main }) => main);
    // @ts-ignore
    const { t } = useTranslation();

    // @ts-ignore
    const unreadedNotifications = getUnreadedNotificationsCount(props.notificationsList);

    const markAllAsRead = async (event: React.MouseEvent) => {
      event.stopPropagation();
      const notificationIds = props.notificationsList.map(item => item.id);
      await crmNotificationsApi.markAsRead(user.id, notificationIds);

      dispatch(markNotificationsAsReadByIds(notificationIds));
      props.handleClose();
    };

    return (
      <ClickAwayListener onClickAway={props.handleClose}>
        <StyledPopper
          open={props.isOpen}
          // @ts-ignore
          anchorEl={anchorRef?.current}
          transition
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: 'left top',
              }}
            >
              <StyledPaper>
                {/* <ClickAwayListener onClickAway={props.handleClose}> */}
                  <div className="inner">
                    <div className="inner-header">
                      <p className="inner-header-notifications">
                        {t('notifications')}
                      </p>
                      <p className="inner-header-settings">
                        <SettingsIcon />
                        {t('settings')}
                      </p>
                    </div>

                    <div className="inner-body">
                      {props.notificationsList.length ? (
                        props.notificationsList.map((record, index) => (
                          <NotificationRecord key={index} record={record} />
                        ))
                      ) : (
                        <NoInfo />
                      )}

                      {/* <NotificationRecord record="text"/> */}
                    </div>

                    <div className="inner-footer">
                      <p className="inner-footer-see-all">{t('see all')}</p>
                      {Boolean(unreadedNotifications.length) && (
                        <UnstyledButton pointer onClick={markAllAsRead}>
                          {t('mark all as read')}
                        </UnstyledButton>
                      )}
                    </div>
                  </div>
                {/* </ClickAwayListener> */}
              </StyledPaper>
            </Grow>
          )}
        </StyledPopper>
      </ClickAwayListener>
    );
  },
);

export default NotificationsModal;
